import React, { useState, useMemo, useContext, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ReactDataTables from "../../customComponents/ReactDataTables";
import { DataTableLoader } from "../../utils/Loader";
import { CompanyContext, AuthContext } from "../../utils/CompanyContext";
import { FormatDate, FormatDateFormat } from "../../utils/dateFormat";
import {
  getMyEvaluationHistoryData,
  myEvaluationHistoryDetailsReact,
} from "../../store/actions";
import { Modal } from "reactstrap";
import EvaluationScreen from "./EvaluationScreen";
import SearchDropdown from "../../customComponents/SearchDropdown";

function MyEvaluation() {
  const dispatch = useDispatch();
  const { CGUID, Loginid, titlerolename } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState("");
  const myEvaluationHistory = useSelector(
    (state) => state.get_my_evaluation_history_data.data || [],
  );
  const isFetchingList = useSelector(
    (state) => state.get_my_evaluation_history_data.isFetching,
  );
  const activityHistoryAllInfo = useSelector(
    (state) => state.my_evaluation_history_details_react.data || [],
  );

  const isFetching = useSelector(
    (state) => state.my_evaluation_history_details_react.isFetching,
  );

  const evalDetailsModal = (rowItem) => {
    toggleModal();
    dispatch(
      myEvaluationHistoryDetailsReact({
        companyguid: CGUID,
        organization: rowItem.organization,
        formid: rowItem?.formid,
        evaluationid: rowItem?.evaluationid,
        titlerolename: titlerolename,
      }),
    );
  };
  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };
  useEffect(() => {
    const fetchData = () => {
      dispatch(
        getMyEvaluationHistoryData({
          companyguid: CGUID,
          evaluatedto: Loginid,
        }),
      );
    };
    fetchData();
  }, [CGUID, Loginid, dispatch]);

  const columns = [
    {
      title: "Evaluation ID",
      data: "evaluationid",
      render: function (data, type, row) {
        return `<span class="row-click row-click-evalhistory">${data}</span>`;
      },
      onClick: (rowData, colIndex) => evalDetailsModal(rowData),
    },
    {
      title: "Organization",
      data: "organization",
    },
    {
      title: "Program",
      data: "programname",
    },
    {
      title: "Evaluation Form",
      data: "formname",
    },
    {
      title: "Date",
      data: "evaluationcreateddate",
      render: (data, type, row) => {
        return `<span class="d-none">${FormatDateFormat(
          data,
          "YYYYMMDD",
        )}</span> ${FormatDate(data)}`;
      },
    },
    {
      title: "Evaluated By",
      data: "evaluatedby",
      render: function (data, type, row) {
        return data
          ? `<span class="">${row.evaluated_by_fname} ${row.evaluated_by_lname}</span>`
          : "";
      },
    },
    {
      title: "Supervisor",
      data: "managername",
    },
    {
      title: "Type of Scoring",
      data: "typeofscoring",
    },
    {
      title: "Goal",
      data: "goal",
    },
    {
      title: "Total Point Score",
      data: "totalpointscored",
    },
    {
      title: "Total Points Possible",
      data: "typeofscoring",
      render: function (data, type, row) {
        return `<span class="">${row.typeofscoring == "average" ? "N/A" : row.maxpoints}</span>`;
      },
    },
    {
      title: `<img className="coaching_history_image col-header-img" src="/images/thumbs_up.svg" />`,
      data: "ack",
      sortable: false,
      render: (data, type, row) => {
        return data
          ? '<img className="coaching_history_image" src="/images/thumbs_up.svg" />'
          : "";
      },
    },
  ];

  const evaluatedByList = useMemo(() => {
    if (!myEvaluationHistory?.length) return [];

    const names = myEvaluationHistory.map((x) =>
      `${x.evaluated_by_fname || ""} ${x.evaluated_by_lname || ""}`.trim(),
    );

    return [...new Set(names)].filter(Boolean);
  }, [myEvaluationHistory]);

  const filteredData = useMemo(() => {
    if (!appliedSearch) return myEvaluationHistory;

    const searchValue = appliedSearch.trim().toLowerCase();

    return myEvaluationHistory.filter((item) => {
      const fullName =
        `${item.evaluated_by_fname || ""} ${item.evaluated_by_lname || ""}`
          .trim()
          .toLowerCase();

      return fullName === searchValue;
    });
  }, [appliedSearch, myEvaluationHistory]);

  return (
    <div className="my-evalution">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="top_bar d-flex justify-content-end align-items-center">
              <SearchDropdown
                data={evaluatedByList}
                placeholder="Search for Evaluated By."
                onSelect={(value) => {
                  setAppliedSearch(value);
                }}
              />
            </div>
            <div className="" id="coaching_history">
              <div className="row">
                <div className="col-md-12">
                  <div className="coach_comparision1">
                    <div className="header_with_border">
                      <h3>Evaluation History</h3>
                    </div>
                    <div
                      className="agent_coaching_history"
                      id="coachingHistory_wrapper"
                    >
                      {isFetchingList ? (
                        <div className="text-center">
                          <DataTableLoader />
                        </div>
                      ) : (
                        <ReactDataTables
                          data={filteredData}
                          columns={columns}
                          defaultSort={{ columnIndex: 0, direction: "desc" }}
                          paging={false}
                          scrollY="75vh"
                          className="pt-2"
                          fixedHeader={{
                            header: false,
                            footer: true,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Modal
          isOpen={showModal}
          toggle={toggleModal}
          backdrop={true}
          keyboard={true}
          id="viewcoach"
          style={{
            maxWidth: "90%",
          }}
        >
          <EvaluationScreen
            dashboard="Details"
            activityHistoryAllInfo={activityHistoryAllInfo}
            isFetching={isFetching}
            toggleModal={toggleModal}
          />
        </Modal>
      )}
    </div>
  );
}

export default MyEvaluation;
